module.exports = __webpack_public_path__ + "img/car.9d67eaf1.svg";